import { render, staticRenderFns } from "./CoffeeVariety.vue?vue&type=template&id=0f6cd6d5&scoped=true"
import script from "./CoffeeVariety.vue?vue&type=script&lang=js"
export * from "./CoffeeVariety.vue?vue&type=script&lang=js"
import style0 from "./CoffeeVariety.vue?vue&type=style&index=0&id=0f6cd6d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6cd6d5",
  null
  
)

export default component.exports